import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { VV } from '@semios/app-platform-value-type-definitions'
import {
  getValueTypeFromEmitterType,
  IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX,
} from '@semios/app-platform-values-helpers-and-types'
import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { getPointLngLatsForIrrigationEmitterZoneId } from 'utils/getPointLngLatsForIrrigationEmitterZoneId'

type IrrigationIntervalType =
  VV.DomainTypes.Irrigation.TValuesReturnWithMetaIgnoringKeying['points']['irrigationActivityIntervalsSemios_emitterBuriedDrip1']

export const getActivityIntervalsFromData = ({
  data,
  selectedFieldAssets,
}: {
  data: routes.Values.Response
  selectedFieldAssets: TSelectedFieldAssetsStoreState
}) => {
  const propertyId = selectedFieldAssets.property
  const irrigationEmitterZoneId = selectedFieldAssets.irrigationZoneEmitter

  if (!propertyId || !irrigationEmitterZoneId) return {}

  const points = getPointLngLatsForIrrigationEmitterZoneId({ propertyId, irrigationEmitterZoneId })
  const { emitterType } = getIdAndEmitterTypeFromZoneEmitterTypeKey(irrigationEmitterZoneId)

  const valueType = getValueTypeFromEmitterType(
    IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX,
    emitterType,
  ) as Extract<
    keyof VV.DomainTypes.Irrigation.TValuesReturnWithMetaIgnoringKeying['irrigationZones'],
    `${typeof IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX}${string}`
  >

  return points.reduce(
    (result, point) => {
      const dataForPoint = data?.points?.[point]?.values?.[valueType] as IrrigationIntervalType

      if (dataForPoint) {
        result[point] = dataForPoint
      }

      return result
    },
    {} as Record<string, IrrigationIntervalType>,
  )
}
